<script lang="ts">
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		src: string;
		srcset?: string;
		sizes?: string;
		alt: string;
		eager?: boolean;
		fallbackSrc?: string;
		width?: string;
		height?: string;
		objectFit?: string;
		fetchPriority?: 'high' | 'low' | 'auto';
		class?: ClassValue;
	}

	let {
		src = $bindable(),
		srcset,
		sizes,
		alt,
		eager = false,
		fallbackSrc,
		width,
		height,
		objectFit = 'cover',
		fetchPriority,
		class: classes,
	}: Props = $props();

	const loading = eager ? undefined : 'lazy';
	const decoding = eager ? 'sync' : 'async';
</script>

<img
	{loading}
	{decoding}
	{src}
	{alt}
	fetchpriority={fetchPriority}
	onerror={() => {
		if (fallbackSrc && src !== fallbackSrc) {
			src = fallbackSrc;
		}
	}}
	class={classes}
	{srcset}
	{sizes}
	style:width
	style:height
	style:object-fit={objectFit}
/>
